// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"d44fc585bebf6d15","node_modules_canvg_lib_index_es_js":"b7df6856c95cdc81"}[chunkId] + ".js";
};